import $log from "@/utils/service/log";

let state = {
    businessName: "",
    website: "",
    email: "",
    phone: "",
    country: "",
    state: "",
    zip: "",
    fax: "",
    address: ""
};

let getters = {
    getAllGeneralInformation(state) {
        return {
            businessName: state.businessName,
            website: state.website,
            email: state.email,
            phone: state.phone,
            country: state.country,
            state: state.state,
            zip: state.zip,
            fax: state.fax,
            address: state.address
        };
    },
    getSingleValue: state => key => {
        return state[key] || null;
    }
};

let mutations = {
    SET_GENERAL_INFORMATION_VALUE(state, { key, value }) {
        try {
            state[key] = value;
        } catch (e) {
            $log.notify(e);
        }
    }
};

export default {
    // namespaced: true,
    state,
    getters,
    mutations
    // actions
};
